import React, { Component } from 'react';
import NoResults from './NoResults';

class Table extends Component {
    constructor(props) {
		super(props);

		this.state = {
			sortColumn: -1,
			sortDirection: -1
		}
		this.onClick = this.onClick.bind(this);
    }

	onClick(e) {
		var index = e.target.dataset.index * 1,
			sortDirection = this.state.sortDirection;

		if (this.state.sortColumn === index) {
			sortDirection = sortDirection * -1;
		} else {
			sortDirection = -1
		}
		this.setState({
			sortColumn: index,
			sortDirection: sortDirection
		});
	}

    render() {

        this.heading = this.props.tableHeading;
        this.body = this.props.tableBody;

        if (this.heading.length === 0 || this.body.length === 0) {
            this.heading = false;
            this.body = false;
            this.noResults = <NoResults message={this.props.noResultsMessage} />;
        } else {
            this.noResults = false;
        }

		if (this.body !== false && this.state.sortColumn > -1) {
			let sort = true,
				sortColumn = this.state.sortColumn,
				temp, one, two = '';
			while (sort) {
				sort = false;
				for (let a = 0; a < this.body.length - 1; a += 1) {
					one = this.body[a][sortColumn] || 0;
					two = this.body[a + 1][sortColumn] || 0;
					if (typeof one === 'object') {
						one = one.props.children + '';
					}
					if (typeof two === 'object') {
						two = two.props.children + '';
					}
					// check for integer compare
					if(!isNaN(one) && !isNaN(two)) {
						one = one * 1;
						two = two * 1;
					}
					if (this.state.sortDirection === 1) {
						temp = one;
						one = two;
						two = temp;
					}
					if (one > two) {
						temp = this.body[a];
						this.body[a] = this.body[a + 1];
						this.body[a + 1] = temp;
						sort = true;
					}
				}
			}
		}

        return (
            <div className="pp-table-wrapper">
                {this.noResults}
                <div className="pp-table-scroll">
                    <table className="pp-table">
                        {this.heading &&
                            <thead className="pp-table-head">
                                <tr className="pp-table-heading-row">
                                    {this.heading.map((heading, index) => (
                                        <td className="pp-table-heading-cell" key={index} data-index={index} onClick={this.onClick}>
                                            <div className="pp-heading-text" data-sort={this.state.sortColumn === index && this.state.sortDirection} data-index={index}>{heading}</div>
                                        </td>
                                    ))}
                                </tr>
                            </thead>
                        }
                        {this.body &&
                            <tbody className="pp-table-body">
                                {this.body.map((row, index) => (
                                    <tr className="pp-table-row" key={index}>
                                        {row.map((cell, index) => (
                                            <td className="pp-table-cell" key={index}>{cell}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        }
                    </table>
                </div>
            </div>
        );
    }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table.js